import React, { FC, useContext } from 'react';
import * as Styled from './HeaderContent.styles';
import { GalleryContext } from '../../hooks/useGalleryContext';
import { Campaign } from '../../types';

type HeaderContentProps = {
  campaign: Campaign | null;
};

export const HeaderContent: FC<HeaderContentProps> = ({ campaign }) => {
  const { galleryActive } = useContext(GalleryContext);

  return (
    <Styled.Container show={!galleryActive}>
      <Styled.Subheader color={campaign?.header_subhead_color}>
        {campaign?.header_subhead}
      </Styled.Subheader>
      <Styled.Title color={campaign?.header_headline_color}>
        {campaign?.header_headline}
      </Styled.Title>
      <Styled.Description color={campaign?.header_description_color}>
        {campaign?.header_description}
      </Styled.Description>
    </Styled.Container>
  );
};
